import { render, staticRenderFns } from "./purchaseHistoryForHc.vue?vue&type=template&id=97f32136&scoped=true"
import script from "./purchaseHistoryForHc.vue?vue&type=script&lang=js"
export * from "./purchaseHistoryForHc.vue?vue&type=script&lang=js"
import style0 from "./purchaseHistoryForHc.vue?vue&type=style&index=0&id=97f32136&prod&scoped=true&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f32136",
  null
  
)

export default component.exports